export enum TimeRangeValues {
  ALL_TIME = 'ALL_TIME',
  LAST_7_DAYS = 'LAST_7_DAYS',
  LAST_24_HOURS = 'LAST_24_HOURS',
  LAST_30_DAYS = 'LAST_30_DAYS',
  THIS_MONTH = 'THIS_MONTH',
  CURRENT_BILLING_PERIOD = 'CURRENT_BILLING_PERIOD',
  CUSTOM = 'CUSTOM',
}
